/**
 * Returns a number or null if input is an empty value
 * used mainly because vue-currency-input accepts only numbers
 * https://vue-currency-input-v1.netlify.app/guide/#component
 *
 * @param {any} val
 * @returns a number or null
 */
export const toNumberOrNull = (val: unknown) => {
  if (val === '' || val === null) {
    return null;
  }

  const num = Number(val);

  return isFinite(num) ? num : null;
};
